import { PaginationScope } from "./PaginationDirective";
import { Store } from "@ngrx/store";
import { RootState, getContestants, entryAvailable, LoadContestantsOnceAction } from "@play/state";
import { filter, map } from "rxjs/operators";

export interface IMyPositionScope extends PaginationScope {
    setPageToContestant();
    leagueId: number;
}

export class MyPositionDirective {
    public restrict = "AE";
    public link: (scope: IMyPositionScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;
    public scope = false;
    public $scope: IMyPositionScope = null;
    public templateUrl = "ranking-pagination/my-position.html";

    constructor(private $location: ng.ILocationService, SettingsService, store: Store<RootState>) {
        MyPositionDirective.prototype.link = (scope: IMyPositionScope) => {
            this.$scope = scope;

            const userId = SettingsService.user ? +SettingsService.user.id : null;

            if (userId) {
                store.dispatch(new LoadContestantsOnceAction(+this.$scope.leagueId, userId));
                store
                    .select(getContestants(+this.$scope.leagueId, userId))
                    .pipe(
                        filter(entryAvailable),
                        map(contestant => (contestant.entry.length ? contestant.entry[0] : null))
                    )
                    .subscribe(contestant => {
                        if (contestant && (contestant.state === "finished" || contestant.state === "playing")) {
                            this.$scope.pagination.contestant = +contestant.id;
                        }
                    });
            }

            this.$scope.setPageToContestant = () => {
                this.setPageToContestant();
            };
        };
    }

    public setPageToContestant() {
        this.$location.search({
            id: this.$scope.pagination.contestant,
            page: null,
        });
    }

    public static instance() {
        const directive = ($location: ng.ILocationService, SettingsService, store: Store<RootState>) => {
            return new MyPositionDirective($location, SettingsService, store);
        };

        directive["$inject"] = ["$location", "SettingsService", "store"];

        return directive;
    }
}
